'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import sendAppError from '@/libs/logger/requests/send-app-error';
import Loader from '@/ui/loader/loader';

export default function Error({
  error,
  // reset,
}: {
  error: Error & { digest?: string }
  // reset: () => void
}) {
  const router = useRouter();

  useEffect(() => {
    sendAppError({
      cause: error.cause,
      digest: error.digest,
      message: error.message,
      name: error.name,
      stack: error.stack,
    })
      .catch(() => null)
      .finally(() => { router.replace('/en-US/error-page'); });
  }, [error, router]);

  return (
    <html lang="en">
      <body style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        width: '100vw',
      }}
      >
        <Loader size={18} />
      </body>
    </html>
  );
}
